export default __webpack_public_path__ + "static/media/o2.48815f3e.jpg";